var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificadoMei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.4,
    height: 15,
    viewBox: "0 0 11.4 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-document",
    "data-name": "Icon ionic-ios-document",
    transform: "translate(-7.313 -3.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2000",
    "data-name": "Caminho 2000",
    d: "M21.381,8h3.731a.2.2,0,0,0,.205-.205h0a1.214,1.214,0,0,0-.439-.939L21.75,4.248a1.317,1.317,0,0,0-.845-.3h0a.3.3,0,0,0-.3.3V7.221A.779.779,0,0,0,21.381,8Z",
    transform: "translate(-6.604 -0.003)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2001",
    "data-name": "Caminho 2001",
    d: "M13.425,6.938v-3H8.512a1.2,1.2,0,0,0-1.2,1.2v12.6a1.2,1.2,0,0,0,1.2,1.2h9a1.2,1.2,0,0,0,1.2-1.2V8.625h-3.6A1.69,1.69,0,0,1,13.425,6.938Z",
    transform: "translate(0 0)",
    fill: "#64c2c8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificadoMei);
export default __webpack_public_path__ + "static/media/certificadoMEI.c259d0de02a21bd2819baafa5f99c9aa.svg";
export { ForwardRef as ReactComponent };